import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=151c6934&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"
import style0 from "./Information.vue?vue&type=style&index=0&id=151c6934&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151c6934",
  null
  
)

export default component.exports